import { formatUbRangeLabel } from "../utils/ulaanbaatarTime";

const statusLabels = {
  PAID: "Төлөгдсөн",
  NOT_PAID: "Төлөгдөөгүй",
};

function labelFromOptions(id, options) {
  if (!id) return null;
  const row = (options || []).find((o) => String(o.value) === String(id));
  return row?.label || String(id);
}

/**
 * Human-readable export filter lines for the Excel modal.
 */
export function describeInvoiceExportFilters(
  searchFields,
  { merchants = [], paymentMethods = [], productTypes = [] } = {},
  excelRange
) {
  const lines = [];
  const tableDate = formatUbRangeLabel(searchFields?.createdAt);
  const excelDate = formatUbRangeLabel(excelRange);
  const dateDiffers =
    tableDate !== excelDate &&
    searchFields?.createdAt?.[0] &&
    excelRange?.[0];

  lines.push({
    key: "excelDate",
    label: "Excel огноо (invoice.createdAt)",
    value: excelDate,
  });
  if (dateDiffers) {
    lines.push({
      key: "tableDate",
      label: "Хүснэгтийн огноо (доод мөр өөр)",
      value: tableDate,
      warn: true,
    });
  }

  lines.push({
    key: "excelColumns",
    label: "Excel багана",
    value:
      "Төлөгдсөн цаг = invoice.paidAt; Сүүлд шинэчлэгдсэн = updatedAt (УБ цаг)",
  });

  if (searchFields?.id) {
    lines.push({ label: "Нэхэмжлэлийн код", value: searchFields.id });
  }
  const merchant = labelFromOptions(searchFields.merchantId, merchants);
  if (merchant) lines.push({ label: "Мерчант", value: merchant });
  if (searchFields.status) {
    lines.push({
      label: "Төлөв",
      value: statusLabels[searchFields.status] || searchFields.status,
    });
  }
  const pm = labelFromOptions(searchFields.paymentMethodId, paymentMethods);
  if (pm) lines.push({ label: "Төлбөрийн суваг", value: pm });
  const pt = labelFromOptions(searchFields.productTypeId, productTypes);
  if (pt) lines.push({ label: "Бүтээгдэхүүн", value: pt });
  if (searchFields.recipient) {
    lines.push({ label: "Хүлээн авагч", value: searchFields.recipient });
  }
  if (searchFields.purpose) {
    lines.push({ label: "Гүйлгээний утга", value: searchFields.purpose });
  }
  if (searchFields.amount) {
    lines.push({ label: "Нэхэмжлэлийн дүн", value: searchFields.amount });
  }
  if (searchFields.fromAccountNumber) {
    lines.push({ label: "Данс (багана)", value: searchFields.fromAccountNumber });
  }
  if (searchFields.settleStatus) {
    lines.push({ label: "Өндөрлөгөө", value: searchFields.settleStatus });
  }

  const hasExtraFilters = lines.some(
    (line) => line.key !== "excelDate" && line.key !== "excelColumns"
  );
  if (!hasExtraFilters) {
    lines.push({
      label: "Бусад шүүлт",
      value: "Байхгүй (зөвхөн огноо)",
    });
  }

  return lines;
}

export const INVOICE_SUMMARY_ROWS = [
  { key: "totalAmount", label: "Нэхэмжлэлийн дүн" },
  { key: "feeAmount", label: "Шимтгэл" },
  { key: "invoiceTotalAmount", label: "Нийт дүн" },
  { key: "bankIncomeAmount", label: "Орлогын дүн" },
  { key: "merchantFee", label: "Мерчантын шимтгэл" },
  { key: "xpayFee", label: "XPay дүн" },
  { key: "spayFee", label: "SPay дүн" },
  { key: "processingFee", label: "Боловсруулалтын дүн" },
  { key: "afterFeeAmount", label: "Эцсийн дүн" },
];
